<template>
  <div class="dashboard page">
    <h1>Dashboard</h1>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped></style>
